import { render } from "./ReservationInformation.vue?vue&type=template&id=ec10d970"
import script from "./ReservationInformation.vue?vue&type=script&lang=js"
export * from "./ReservationInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__